/**
 * Последняя попытка студента — та же, по чьему баллу бэкенд сортирует список
 * «По уровню доверия» (MAX(id) среди попыток, которые вернул /students).
 */
export function getLastAttempt<T extends { id: number }>(
  attempts: readonly T[]
): T | null {
  return attempts.reduce<T | null>(
    (last, attempt) => (last == null || attempt.id > last.id ? attempt : last),
    null
  );
}
